var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2 p-sm-4 bg-white rounded-lg h-100 overflow-hidden"},[_c('DataTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }